import FilterSection from 'components/FilterPopover/FilterSection';
import Checkbox from 'components/inputs/Checkbox';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { RFIQuery } from 'records/RFIQuery';
import { User } from 'records/User';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  rfiQuery: RFIQuery;
  updateRFIQuery: (nextRFIQuery: RFIQuery) => void;
}

const AssigneeFilterSection: React.FC<Props> = (props: Props) => {
  const { rfiQuery, updateRFIQuery } = props;
  const { state: appState } = useContext(AppStoreContext);
  const { translate } = useTranslator(['filters']);

  const allAssignees = appState.rfis
    .valueSeq()
    .flatMap((rfi) => rfi.assignees)
    .toOrderedSet()
    .sortBy((user) => user.email);

  /* Handlers */
  function onCheckboxChange(assignee: User): void {
    const nextPunchQuery = rfiQuery.update('assignees', (assignees) => {
      return assignees.some((a) => a.id === assignee.id)
        ? assignees.filter((a) => a.id !== assignee.id)
        : assignees.add(assignee);
    });

    updateRFIQuery(nextPunchQuery);
  }

  const appliedFilters = rfiQuery.assignees
    .map((a) => a.email)
    .sort()
    .toArray();

  return (
    <FilterSection
      label={translate('filters:assignee')}
      appliedFilters={appliedFilters}
      disabled={false}
    >
      <div className="h100 oa px4 py3">
        {allAssignees.map((assignee: User): React.ReactNode => {
          return (
            <div
              key={assignee.id}
              className="row mb3 cursor-pointer disable-select"
              onClick={() => onCheckboxChange(assignee)}
            >
              <Checkbox
                id={`punch-filter-popover-location-checkbox-${assignee.id}`}
                onChange={() => onCheckboxChange(assignee)}
                checked={rfiQuery.assignees.some((a) => a.id === assignee.id)}
              />
              <div className="ml2 truncate">{assignee.email}</div>
            </div>
          );
        })}
      </div>
    </FilterSection>
  );
};

export default AssigneeFilterSection;
